import commonApi from 'apis/commonApi';
import game3rdApi from 'apis/game3rdApi';
import { RootState, useAppDispatch, useAppSelector } from 'cache/store';
import alertMsg from 'components/alert-message/alert-message';
import GameList from 'components/home/game-list';
import LoadingIcon from 'components/loading/LoadingIcon';
import MarqueeComponent from 'components/marquee/Marquee';
import Modal from 'components/modal/Modal';
import { listHeaderMenuCopy } from 'constants/common';
import globalStyle from 'constants/global.style';
import { toggleShowFirstNotice } from 'features/msgSystemSlice';
import { Game3rdMenuItem, MenuHeaderItem } from 'models/commonModel';
import { NotiDetailModel } from 'models/notiModel';
import { PromoDetailResponse } from 'models/promotionModel';
import { MsgDetail } from 'pages/homepage/msg-detail/msg-detail';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './header-menu.style';
import HeaderMenuLottery from './HeaderMenuLottery';

function HeaderMenu() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const { menuGame, showFirstNotice } = useAppSelector((state: RootState) => state.system);
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const [menuGameList, setMenuGameList] = useState<MenuHeaderItem[]>(menuGame);
    const [hoveredMenuIndex, setHoveredMenuIndex] = useState<number | null>(null);

    const [marqueeTextList, setMarqueeTextList] = useState<PromoDetailResponse[]>([]);
    const [loading, setLoading] = useState(false);
    const [showMsgDetail, setShowMsgDetail] = useState(false);
    const [msgDetail, setMsgDetail] = useState<NotiDetailModel>({} as NotiDetailModel);

    const [dataGameSlot, setDataGameSlot] = useState<{ title: string; product: string; category: string }>();

    useEffect(() => {
        const initMsgSystemBean = async () => {
            try {
                const { data } = await commonApi.getMsgSystemBean({});
                if (!data.msg) {
                    //danh sách thông báo marquee top
                    const marqueeData: PromoDetailResponse[] = data.msglist.filter((item: PromoDetailResponse) => item.status === 1);

                    if (!showFirstNotice) {
                        // popup first login
                        const notiList: PromoDetailResponse[] = data.msglist.filter((item: PromoDetailResponse) => item.status === 2);
                        if (notiList.length > 0) {
                            setTimeout(() => {
                                selectDetailMsg(notiList[0].id);
                            }, 1500);
                        }
                        dispatch(toggleShowFirstNotice(true));
                    }

                    setMarqueeTextList(marqueeData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        initMsgSystemBean();
    }, []);

    useEffect(() => {
        if (menuGame.length > 0) {
            const lotteryMenu: MenuHeaderItem = {
                name: 'Xổ Số',
                child: [],
                isMain: false,
                isLottery: true,
                path: '/lottery',
            };
            let newMenuGame = [...menuGame].filter((item) => !(item.child && item.child.length === 0));
            newMenuGame.splice(2, 0, lotteryMenu);

            newMenuGame = newMenuGame.map((group) => {
                if (group.gametype === 'LC' && group.child) {
                    return {
                        ...group,
                        child: group.child.filter((item) => item.providercode !== 'TX').map((item) => ({ ...item, name: item.providercode === 'XD' ? 'VUIBET CASINO' : item.name })),
                        isHot: false,
                    };
                }

                if (group.gametype === 'SB') {
                    return { ...group, isHot: false };
                }

                return group;
            });

            newMenuGame = listHeaderMenuCopy.map((item) => {
                const game = newMenuGame.find((o) => o.path === item.key || o.gametype === item.key);

                if (game) {
                    const itemChildList = (Array.isArray(item?.child) ? item.child : []) as Game3rdMenuItem[];

                    const child = item.child?.map((itemChild: any) => {
                        const itemChildCopy = itemChildList.find((o) => o.gametype === itemChild.gametype && o.providercode === itemChild.providercode && o.name === itemChild?.name);
                        return { ...(itemChildCopy ?? {}), ...itemChild };
                    });

                    return {
                        ...game,
                        name: item.name || game.name,
                        child,
                    };
                }

                return item as any;
            });

            setMenuGameList(newMenuGame);
        }
    }, [menuGame]);

    const onHoverMenuGame = (index: number, isHover: boolean) => {
        setHoveredMenuIndex(isHover ? index : null);
    };

    const selectGame = async (game: Game3rdMenuItem, index: number) => {
        if (!isLogged) {
            alertMsg('Vui lòng đăng nhập');
            onHoverMenuGame(index, false);
            return;
        }

        const findGame = menuGame.find((o) => o.gametype == game.gametype)?.child?.find((o) => o.providercode == game.providercode && (game.category ? o.category === game.category : true));

        if (!game.providercode || !game.gametype || game.providercode === 'TX' || !findGame || findGame.ismaintain == '1') {
            return toast.error('Game đang bảo trì');
        }

        if (findGame.islist == '1') {
            setDataGameSlot({ category: findGame.category, product: findGame.product, title: findGame.name });
        } else {
            setLoading(true);
            try {
                const { data } = await game3rdApi.launchGame({ product: findGame?.product, category: findGame.category, html5: 'WEB' } as any);
                if (!data.msg) {
                    window.open(data.url, '_blank');
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
    };

    const selectDetailMsg = async (id: number) => {
        setLoading(true);
        try {
            const { data } = await commonApi.sysMsgBeanInfo({ id });
            if (!data.msg) {
                setShowMsgDetail(true);
                setMsgDetail({
                    title: data.sysmsg.title,
                    content: data.sysmsg.content,
                    photourl: data.sysmsg.photourl || '',
                });
            } else {
                toast.error(data.msg);
            }
            // show popup thông báo
            setShowMsgDetail(true);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const activeMenuItem = hoveredMenuIndex === null ? undefined : menuGameList[hoveredMenuIndex];
    const isDropdownOpen = Boolean(activeMenuItem && (activeMenuItem.isLottery || activeMenuItem.child?.length));

    return (
        <>
            <div className={styles.wrap} onMouseLeave={() => setHoveredMenuIndex(null)}>
                <div className={globalStyle.container}>
                    <ul className={styles.menuList}>
                        {menuGameList.map((item, index) => (
                            <li
                                className={`${styles.menuItem} ${item.path === '/' ? (location.pathname === '/' ? 'active' : '') : item.path && location.pathname.startsWith(item.path) ? 'active' : ''}`}
                                key={index}
                                onClick={() => {
                                    if (item.path) {
                                        navigate(item.path);
                                    } else if (item.page) {
                                        navigate(item.page);
                                    }
                                }}
                                onMouseEnter={() => onHoverMenuGame(index, true)}
                            >
                                {item.path === '/' ? (
                                    <div className={styles.itemGame}>
                                        <h6 className={styles.menuLink}>TRANG CHỦ</h6>
                                    </div>
                                ) : item.path === `/promotion` ? (
                                    <div className={styles.itemGamePromotion}>
                                        <h6 className={styles.menuLinkPromotion}>{`KHUYẾN MÃI`}</h6>
                                    </div>
                                ) : (
                                    <div className={styles.itemGame}>
                                        {item.isHot && <img className="new" src={require('assets/images/icons/header-home/new_game.png')} alt="" />}
                                        <h6 className={styles.menuLink}>{item.name}</h6>
                                    </div>
                                )}
                            </li>
                        ))}

                    </ul>
                </div>
                <div className={`${styles.baseGameHover} ${isDropdownOpen ? styles.baseGameHoverOpen : ''}`}>
                    {isDropdownOpen && <div className={`${globalStyle.container} ${styles.showMenuGame}`}>
                        <div className={`${styles.gameList} game-list`}>
                            {activeMenuItem?.isLottery ? (
                                <HeaderMenuLottery onCloseMenu={onHoverMenuGame} menuIndex={hoveredMenuIndex as number} />
                            ) : (
                                <div className={styles.containerGameList}>
                                    {activeMenuItem?.child?.map((game, i) => (
                                        <div className={styles.gameItem} key={`${game.gametype}-${game.providercode}-${i}`}>
                                            {game?.isHot && <img className="new" src={require('assets/images/icons/header-home/new_game.png')} alt="" />}
                                            <div className="gameArtwork">
                                                <img
                                                    alt={game.name || ''}
                                                    src={game.image || game.iconpc}
                                                    onClick={() => {
                                                        if (!game?.child?.length) {
                                                            selectGame(game as Game3rdMenuItem, hoveredMenuIndex as number);
                                                        }
                                                    }}
                                                    className={styles.pointerGame}
                                                />
                                            </div>
                                            {game?.child && <div className="contentGame">
                                                {game.child.map((typeGame, childIndex) => <div
                                                    onClick={() => {
                                                        if (!isLogged) {
                                                            alertMsg('Vui lòng đăng nhập');
                                                            return;
                                                        }
                                                        toast.error('Game đang bảo trì');
                                                    }}
                                                    className="buttonType"
                                                    key={`${typeGame.title}-${childIndex}`}
                                                ><p className={styles.gameName}>{typeGame.title}</p></div>)}
                                            </div>}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>}
                </div>
            </div>
            <div className={styles.marquee}>
                <div className={globalStyle.container}>
                    <div className={styles.slideTimer}>
                        <div className={styles.timeNow}>
                            <img className={styles.megaphone} src={require('assets/images/icons/header-home/notifi.png')} alt="" />
                            <p className={styles.titleNoti}>{'THÔNG BÁO: '}</p>
                        </div>
                        <div className={styles.slideText}>
                            <MarqueeComponent dataList={marqueeTextList} onShowDetail={selectDetailMsg} />
                        </div>
                    </div>
                </div>
            </div>

            <Modal isShow={showMsgDetail} onClose={() => setShowMsgDetail(false)} width="62vw" closeClickBackdrop>
                <MsgDetail data={msgDetail} onClose={() => setShowMsgDetail(false)} />
            </Modal>

            {/* list game slot  */}
            <GameList dataGame={dataGameSlot} onClose={() => setDataGameSlot(undefined)} />

            {loading && <LoadingIcon />}
        </>
    );
}

export default HeaderMenu;
